<div class="main-content">
	<div class="container-fluid">
		<div class="row">
			<div class="col-md-12">
				<div class="card">
					<div class="card-header card-header-{{color}}-6">
						<h4 class="card-title">
							<i class="material-icons" (click)="back()">arrow_left</i>
							Sales Dashboard
						</h4>
						<p class="card-category text-right">Year-Over-Year Supplier Sales</p>
					</div>
					<div class="card-body">

						<!-- Filters -->
						<div class="row">
							<div class="col-md-2">
								<mat-form-field appearance="outline" class="w-100">
									<mat-label>Year</mat-label>
									<mat-select [formControl]="yearRef">
										<mat-option *ngFor="let y of years" [value]="y">{{ y }}</mat-option>
									</mat-select>
								</mat-form-field>
							</div>
							<div class="col-md-2">
								<mat-form-field appearance="outline" class="w-100">
									<mat-label>Month</mat-label>
									<mat-select [formControl]="monthRef">
										<mat-option *ngFor="let m of months" [value]="m.value">{{ m.label }}</mat-option>
									</mat-select>
								</mat-form-field>
							</div>
							<div class="col-md-3">
								<mat-form-field appearance="outline" class="w-100">
									<mat-label>Branch / Location</mat-label>
									<mat-select [formControl]="branchRef">
										<mat-option value="">All Locations</mat-option>
										<mat-option *ngFor="let b of branches" [value]="b.loccode">{{ b.locationname }}</mat-option>
									</mat-select>
								</mat-form-field>
							</div>
							<div class="col-md-3" *ngIf="salespeople.length > 1">
								<mat-form-field appearance="outline" class="w-100">
									<mat-label>Salesperson</mat-label>
									<mat-select [formControl]="salespersonRef" multiple>
										<mat-option *ngFor="let s of salespeople" [value]="s.salesmancode">{{ s.salesmanname }}</mat-option>
									</mat-select>
								</mat-form-field>
							</div>
							<div class="col-md-2">
								<button mat-raised-button color="accent" class="mt-2" (click)="runReport()" [disabled]="sending">
									<mat-icon class="p-0">search</mat-icon> Search
								</button>
								<span *ngIf="sending" class="ml-2">
									<svg class="spinner" width="35px" height="35px" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg">
										<circle class="path" fill="none" stroke-width="6" stroke-linecap="round" cx="33" cy="33" r="30"></circle>
									</svg>
								</span>
							</div>
						</div>

						<!-- Export + period label -->
						<div class="row mt-2 mb-2" *ngIf="results.length && !sending">
							<div class="col-md-12">
								<button class="btn btn-success btn-sm mr-2" (click)="exportXls()">
									<i class="fa fa-file-excel-o"></i> XLS
								</button>
								<button class="btn btn-danger btn-sm" (click)="exportPdf()">
									<i class="fa fa-file-pdf-o"></i> PDF
								</button>
								<span class="ml-3 text-muted" style="font-size:.85rem;">
									{{ getMonthName(month) }} {{ year }} vs {{ lastyear }}
								</span>
							</div>
						</div>

						<!-- KPI summary strip -->
						<div class="row mb-3" *ngIf="kpi && !sending">
							<div class="col-md-4">
								<div class="kpi-card">
									<div class="kpi-card__label">Month Sales</div>
									<div class="kpi-card__value">{{ formatCurrencyCompact(kpi.totalSales) }}</div>
									<div class="kpi-card__sub">
										vs {{ formatCurrencyCompact(kpi.totalSalesLY) }} LY &nbsp;
										<span [class.text-success]="isPositive(kpi.salesPct)" [class.text-danger]="isNegative(kpi.salesPct)">
											{{ formatPercent(kpi.salesPct) }}
										</span>
									</div>
								</div>
							</div>
							<div class="col-md-4">
								<div class="kpi-card">
									<div class="kpi-card__label">YTD Sales</div>
									<div class="kpi-card__value">{{ formatCurrencyCompact(kpi.totalYTD) }}</div>
									<div class="kpi-card__sub">
										vs {{ formatCurrencyCompact(kpi.totalYTDLY) }} LY &nbsp;
										<span [class.text-success]="isPositive(kpi.ytdPct)" [class.text-danger]="isNegative(kpi.ytdPct)">
											{{ formatPercent(kpi.ytdPct) }}
										</span>
									</div>
								</div>
							</div>
							<div class="col-md-4">
								<div class="kpi-card">
									<div class="kpi-card__label">Active Customers</div>
									<div class="kpi-card__value">{{ kpi.activeCustomers | number }}</div>
									<div class="kpi-card__sub">
										vs {{ kpi.activeCustomersLY | number }} LY &nbsp;
										<span [class.text-success]="kpi.activeCustomers >= kpi.activeCustomersLY" [class.text-danger]="kpi.activeCustomers < kpi.activeCustomersLY">
											{{ formatDiff(kpi.activeCustomers - kpi.activeCustomersLY) }}
										</span>
									</div>
								</div>
							</div>
						</div>

						<!-- Results table -->
						<div class="table-responsive" #printTable *ngIf="results.length && !sending">
							<table class="table table-bordered table-striped table-hover dashboard-table">
								<thead class="thead-dark">
									<tr>
										<th rowspan="2" class="align-middle sortable" (click)="sortBy('name')">
											Brand / Category <mat-icon class="sort-icon">{{ getSortIcon('name') }}</mat-icon>
										</th>
										<th colspan="3" class="text-center group-actives">Active Customers</th>
										<th colspan="4" class="text-center group-sales">Month Sales</th>
										<th colspan="3" class="text-center group-ytd">Year to Date</th>
									</tr>
									<tr>
										<!-- Actives -->
										<th class="text-right sortable" (click)="sortBy('actives')">{{ year }} <mat-icon class="sort-icon">{{ getSortIcon('actives') }}</mat-icon></th>
										<th class="text-right sortable" (click)="sortBy('activesly')">{{ lastyear }} <mat-icon class="sort-icon">{{ getSortIcon('activesly') }}</mat-icon></th>
										<th class="text-right sortable" (click)="sortBy('activesdiff')">+/- <mat-icon class="sort-icon">{{ getSortIcon('activesdiff') }}</mat-icon></th>
										<!-- Sales -->
										<th class="text-right sortable" (click)="sortBy('sales')">{{ year }} <mat-icon class="sort-icon">{{ getSortIcon('sales') }}</mat-icon></th>
										<th class="text-right sortable" (click)="sortBy('salesly')">{{ lastyear }} <mat-icon class="sort-icon">{{ getSortIcon('salesly') }}</mat-icon></th>
										<th class="text-right sortable" (click)="sortBy('salesdiff')">+/- <mat-icon class="sort-icon">{{ getSortIcon('salesdiff') }}</mat-icon></th>
										<th class="text-right sortable" (click)="sortBy('salesdiffpercent')">+/-% <mat-icon class="sort-icon">{{ getSortIcon('salesdiffpercent') }}</mat-icon></th>
										<!-- YTD -->
										<th class="text-right sortable" (click)="sortBy('salesytd')">{{ year }} <mat-icon class="sort-icon">{{ getSortIcon('salesytd') }}</mat-icon></th>
										<th class="text-right sortable" (click)="sortBy('salesytdly')">{{ lastyear }} <mat-icon class="sort-icon">{{ getSortIcon('salesytdly') }}</mat-icon></th>
										<th class="text-right sortable" (click)="sortBy('salesytddiff')">+/-% <mat-icon class="sort-icon">{{ getSortIcon('salesytddiff') }}</mat-icon></th>
									</tr>
								</thead>
								<tbody>
									<ng-container *ngFor="let row of results; trackBy: trackByName">
										<tr *ngIf="!isHidden(row)"
											[class.row-total]="isTotal(row)"
											[class.row-colour]="row.name === 'Colour'">

											<td>
												<strong *ngIf="isTotal(row)">{{ row.name }}</strong>
												<span *ngIf="!isTotal(row)">{{ row.name }}</span>
											</td>

											<!-- Actives -->
											<td class="text-right">{{ row.actives | number }}</td>
											<td class="text-right text-muted">{{ row.activesly | number }}</td>
											<td class="text-right"
												[class.text-danger]="isNegative(row.activesdiff)"
												[class.text-success]="isPositive(row.activesdiff)">
												{{ formatDiff(row.activesdiff) }}
											</td>

											<!-- Month sales -->
											<td class="text-right mono">{{ formatCurrency(row.sales) }}</td>
											<td class="text-right mono text-muted">{{ formatCurrency(row.salesly) }}</td>
											<td class="text-right mono"
												[class.text-danger]="isNegative(row.salesdiff)"
												[class.text-success]="isPositive(row.salesdiff)">
												{{ formatCurrency(row.salesdiff) }}
											</td>
											<td class="text-right">
												<span class="pct-pill"
													[class.pct-pill--up]="isPositive(row.salesdiffpercent)"
													[class.pct-pill--down]="isNegative(row.salesdiffpercent)">
													{{ formatPercent(row.salesdiffpercent) }}
												</span>
											</td>

											<!-- YTD -->
											<td class="text-right mono">{{ formatCurrency(row.salesytd) }}</td>
											<td class="text-right mono text-muted">{{ formatCurrency(row.salesytdly) }}</td>
											<td class="text-right">
												<span class="pct-pill"
													[class.pct-pill--up]="isPositive(row.salesytddiff)"
													[class.pct-pill--down]="isNegative(row.salesytddiff)">
													{{ formatPercent(row.salesytddiff) }}
												</span>
											</td>

										</tr>
									</ng-container>
								</tbody>
							</table>
						</div>

						<!-- Empty state -->
						<div class="text-center text-muted py-5" *ngIf="!results.length && !sending">
							<i class="material-icons" style="font-size:48px;opacity:.3;">bar_chart</i>
							<p class="mt-2">Select filters above and click <strong>Search</strong> to load the report.</p>
						</div>

					</div>
				</div>
			</div>
		</div>
	</div>
</div>
